export { StoreRecentlyViewed } from './src/store-recently-viewed';
